// src/presets/lara/blockui/index.ts
var blockui_default = {
  root: {
    borderRadius: "{content.border.radius}"
  }
};
export { blockui_default as default };
